import styled from 'styled-components';
import React from 'react';
import { Checkbox } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, } from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '../../utils';
import { SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_SPACE_RELATIVE_2_XS, } from '@oneaudi/unified-web-alpha-common';
export const StyledColorNameLabel = styled.p `
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  display: inline;

  @media (min-width: ${SYS_BREAKPOINT_MD}) and (max-width: calc(${SYS_BREAKPOINT_LG} - 1px)) {
    display: block;
  }
`;
export const StyledCountLabel = styled(StyledColorNameLabel) ``;
export const StyledCheckboxColorTile = styled((props) => React.createElement(Checkbox, Object.assign({}, props))) `
  grid-template-columns: 48px auto;
  grid-template-rows: 48px auto;
  grid-template-areas: 'colortile label';
  align-items: center;
  justify-items: start;
  display: grid;
  margin-block-end: ${(props) => props.isPlpQuickFilters
    ? dynamicStylingHelper(SYS_SPACE_FIXED_200, '0')
    : dynamicStylingHelper(SYS_SPACE_FIXED_300, '')};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    grid-template-columns: ${(props) => (props.isPlpQuickFilters ? 'unset' : '88px')};
    grid-template-rows: unset;
    grid-template-areas: 'colortile' 'label';
    grid-row-gap: var(
      ${(props) => props.isPlpQuickFilters ? 'unset' : dynamicStylingHelper('--spacing-relative-sm', 'unset')}
    );
    align-items: start;
  }

  label {
    display: flex;
    align-items: center;
    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: ${(props) => (props.isPlpQuickFilters ? 'flex' : 'grid')};
      grid-template: 'colortile' 88px 'label' / 88px;
    }

    span {
      display: none;
    }

    div:last-child {
      display: block;
      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        margin-block-start: ${SYS_SPACE_FIXED_150};
        margin-inline-start: 4px;
      }
    }
    position: relative;
    ::after {
      ${(props) => props.disabled &&
    props.isPlpQuickFilters &&
    dynamicStyling({
        alpha: `
          content: '';
          position: absolute;
          top: 50%;
          left: calc(50% - 6px);
          width: 22px;
          height: 2px;
          background-color: white;
          transform: translate(-50%, -50%) rotate(-45deg);

          @media (min-width: ${SYS_BREAKPOINT_MD}) {
            left: calc(50% - 8px);
          }
        `,
    })};
    }
  }

  input {
    background-image: url(${(props) => props.colorUrl});
    background-position: center;
    height: 40px !important;
    width: 40px;
    margin: ${dynamicStylingHelper('4px', SYS_SPACE_RELATIVE_2_XS)};
    height: ${(props) => (props.isPlpQuickFilters ? '42px !important' : '40px !important')};
    width: ${(props) => (props.isPlpQuickFilters ? '42px' : '40px')};
    grid-area: colortile;
    appearance: none;
    clip-path: unset;
    opacity: 1;

    overflow: visible;
    position: relative;

    mask: none;
    border: none;
    border-radius: ${(props) => (props.isPlpQuickFilters ? '50px' : '0')};

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      height: ${(props) => props.isPlpQuickFilters ? '42px !important' : '80px !important'};
      width: ${(props) => (props.isPlpQuickFilters ? '42px' : '80px')};
    }

    &::before {
      content: '';
      display: block;
      position: relative;
      transform: none;
      border: 1px solid transparent;
      height: ${(props) => (props.isPlpQuickFilters ? '46px' : '44px')};
      width: ${(props) => (props.isPlpQuickFilters ? '46px' : '44px')};
      margin: 1px;
      top: -4px;
      left: -4px;
      mask: none;
      background-color: transparent;

      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        height: ${(props) => (props.isPlpQuickFilters ? '46px' : '88px')};
        width: ${(props) => (props.isPlpQuickFilters ? '46px' : '88px')};
        margin: 3px;
        top: ${(props) => (props.isPlpQuickFilters ? '-6px' : '-8px')};
        left: ${(props) => (props.isPlpQuickFilters ? '-6px' : '-8px')};
      }
    }
    &:disabled::before {
      background-color: transparent;
    }
    &:checked::before {
      background-color: transparent;
      border: 1px solid ${dynamicStylingHelper('black', SYS_COLOR_SURFACE_NEUTRAL_100_DARK)};
      border-radius: inherit;
    }
    &:disabled {
      opacity: ${(props) => (props.isPlpQuickFilters ? '0.6' : '1')};
    }
    &:disabled::after {
      ${(props) => !props.isPlpQuickFilters &&
    dynamicStyling({
        alpha: `
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 40px;
          height: 2px;
          background-color: white;
          transform: translate(-50%, -50%) rotate(-45deg);

          @media (min-width: ${SYS_BREAKPOINT_MD}) {
            width: 75px;
          }
        `,
    })};
    }
  }

  input + div {
    grid-area: label;
  }
`;
